<template>
  <div class="home_H">
    <div class="gg_ret_div">
      <div class="gg_ret_div_div">

        <div class="gg_ret_div_div_div">
          <div
              class="gg_ret_div_div_butts"
              @mouseenter="showSquareA = true"
              @mouseleave="showSquareA = false"
          >
            <div class="flex justify-center">
              <img
                  class="gg_ret_div_div_butts_i"
                  src="@/assets/we_4a5ffc8204.svg"
                  alt=""
              />
            </div>
            <el-button type="text">大客户经理</el-button>
            <div v-if="showSquareA" class="square">
              <div>
                <img src="@/assets/weixin.jpg" alt="">
              </div>
              <div>大客户经理</div>
            </div>
          </div>

          <div
              class="gg_ret_div_div_butts"
              @mouseenter="showSquareC = true"
              @mouseleave="showSquareC = false"
          >
            <div class="flex justify-center">
              <img
                  class="gg_ret_div_div_butts_i"
                  src="@/assets/93.svg"
                  alt=""
              />
            </div>
            <el-button type="text">电话客服</el-button>
            <div v-if="showSquareC" class="squareC">
              <div>
                <i class="el-icon-phone-outline"></i>
              </div>
              <div>
                {{ this.$tel }}
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showSquareA: false, // 控制正方形的显示与隐藏
      showSquareB: false, // 控制正方形的显示与隐藏
      showSquareC: false, // 控制正方形的显示与隐藏
    };
  },
  components: {},
  mounted() {
  },
  methods: {
    openWeChatChat() {
    },
  },
};
</script>

<style scoped>
.gg_ret_div_div_butts {
  position: relative; /* 使子元素绝对定位相对于此元素 */
}

.square {
  padding-left: 10px;
  box-shadow: 0 0 9px 0 #eaeef3;
  border: 1px solid #edf3fb;
  padding: 5px 0px 5px 0px;
  border-radius: 10px;
  width: 160px; /*正方形的宽度 */
  height: auto; /* 正方形的高度 */
  background-color: #edf3fc; /* 正方形的背景颜色 */
  position: absolute; /* 绝对定位 */
  left: -190px; /* 左边距，确保正方形在按钮左边 */
  top: 50%; /* 垂直居中 */
  transform: translateY(-50%); /* 垂直居中 */
  z-index: 10; /* 确保正方形在其他元素之上 */
  color: #1da7b9;
}

.square img {
  width: 150px;
  height: auto;
}

.squareC {
  text-align: center;
  box-shadow: 0 0 9px 0 #eaeef3;
  border: 1px solid #edf3fb;
  padding: 5px 10px 5px 0px;
  border-radius: 10px;
  width: 150px; /*正方形的宽度 */
  height: 50px; /* 正方形的高度 */
  background-color: #edf3fc; /* 正方形的背景颜色 */
  position: absolute; /* 绝对定位 */
  left: -190px; /* 左边距，确保正方形在按钮左边 */
  top: 50%; /* 垂直居中 */
  transform: translateY(-50%); /* 垂直居中 */
  z-index: 10; /* 确保正方形在其他元素之上 */
  color: #1da7b9;
}

.home_H {
  position: relative;
}

.show_div_img_main {
  position: fixed;
  z-index: 101;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.show_div_img_main > div {
  display: flex;
  justify-content: center;
}

.show_div_img_main img {
  position: absolute;
  top: 260px;
  width: 400px;
  margin: 0 auto;
}

.guanbi_div {
  font-size: 20px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  color: #edf3fc;
  margin: 0 auto;
  margin-top: 690px;
}

.el-icon-circle-close {
  font-size: 30px;
  color: #edf3fc;
}

.gg_left_img {
  position: fixed;
  bottom: 30px;
  left: 24px;
  z-index: 99;
  display: block;
}

.gg_ret_div {
  position: fixed;
  bottom: 200px;
  right: 0px;
  z-index: 99;
  display: block;
}

.gg_left_top {
  position: fixed;
  bottom: 120px;
  right: 24px;
  z-index: 99;
  display: block;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #edf3fc;
  box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.5);
}

.gg_left_top > div {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.gg_left_top_i {
  font-size: 20px;
}

.gg_left_top > div > div {
  color: #a6bad3;
  font-size: 13px;
}

.gg_ret_div_div {
  width: 81px;
  height: auto;
  background: #edf3fc;
  box-shadow: 0 0 29px 0 rgba(210, 228, 251, 0.59);
  border-radius: 77px;
  font-family: SourceHanSansCN-Regular;
  padding: 12px 0 40px;
}

.gg_ret_div_div_butts {
  /* width: 68px; */
  height: 81px;
  /* padding-bottom: 20px; */
  display: flex;
  justify-content: space-around;
  flex-direction: column;
}

.gg_ret_div_div_butts > button {
  font-size: 13px;
  color: #475c77;
  margin-top: 1px;
  text-align: center;
}

.gg_ret_div_div_div {
}

.gg_ret_div_div_butts_i {
  width: 28px;
  height: 28px;
}

.el-icon-arrow-down,
.el-icon-user {
  font-weight: 600;
}

.el-header,
.el-footer {
  color: #333;
  text-align: center;
  line-height: 60px;
  padding: 0;
}

.el-header {
  position: sticky;
  top: 0;
  background-color: #edf3fc;
  z-index: 5;
}

.top_index {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.mainbody {
  display: flex;
  justify-content: space-between;
  width: 1000px;
  z-index: 1;
  /* background-color: aqua; */
}

.mainbody > div {
  width: 100%;
  display: flex;
  justify-content: space-around;
  font-weight: 600;
}

/* .mainbody>div>div{

} */

.letlogs {
  width: 17%;
  display: flex;
  justify-content: center;
  font-size: 40px;
  font-weight: 700;
}

.log {
  width: 50px;
  height: 50px;
  background-image: url("../../assets/log.png");
  background-size: cover;
}

.imgstop {
  width: 100%;
  height: 50px;
  background-image: url("../../assets/tops.png");
  background-size: cover;
}

.imgstop > div div {
  color: #f15a24;
}

.imgstop_text {
  display: flex;
  justify-self: center;
  background-color: #edf3fc;
  font-size: 25px;
  font-weight: 550;
}

.showdiv {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: #edf3fc;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
  rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
}

.title {
  padding: 0 15px 0 15px;
  display: inline-block;
  position: relative;
}

.showdiv_for {
  width: 100%;
  display: flex;
  justify-content: space-around;
  font-family: SourceHanSansCN-Regula;
}

.for_div_for {
  width: 300px;
  background-color: #409eff;
}

.showdivlist_lable {
  text-align: left;
  padding-left: 10px;
  font-size: 15px;
}

.spans {
  display: block;
  float: left;
  padding: 10px;
  font-size: 15px;
  line-height: 20px;
}

.spans_div {
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: left;
  padding-left: 10px;
}

.span_text {
  font-size: 13px;
  margin-top: 5px;
  white-space: nowrap;
}

.title::after {
  content: "";
  position: absolute;
  width: 100%;
  transform: scaleX(0);
  height: 3px;
  bottom: 0;
  left: 0;
  background-color: #409eff;
  transform-origin: bottom right;
  transition: transform 0.25s ease-out;
}

.title:hover {
  color: #409eff;
}

.title:hover::after {
  transform: scaleX(1);
  transform-origin: bottom left;
}

.main_body {
  display: flex;
  justify-content: center;
  flex-direction: column;
  scrollbar-width: none;
  padding: 0;
  margin-top: 100px;
}

.H_div_A {
  font-size: 54px;
  font-family: SourceHanSansCN-Medium;
  text-align: center;
  color: #0e0b3d;
}

.H_div_B {
  font-size: 54px;
  font-family: SourceHanSansCN-Medium;
  text-align: center;
  color: #0e0b3d;
}

.H_div_C {
  display: inline-block;
  font-size: 22px;
  color: #444e72;
  text-align: center;
  width: 100%;
  margin-top: 25px;
}

.H_div_D {
  font-size: 14px;
  display: flex;
  justify-content: center;
  background-color: #edf3fc;
}

.div_li {
  padding: 0;
  display: flex;
  align-items: center;
  width: 190px;
  margin-top: 16px;
  font-size: 16px;
  font-family: SourceHanSansCN-Medium;
  color: #252b42;
  line-height: 16px;
  margin-left: 6px;
}

.butts_main {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 49px;
  color: #edf3fc;
  column-gap: 14px;
}

.zhu_ {
  display: block;
  font-size: 14px;
  color: #988f91;
  text-align: center;
  margin-top: 44px;
}

.butt_A {
  cursor: pointer;
  text-align: center;
  width: 191px;
  height: 54px;
  font-size: 18px;
  color: #edf3fc;
  background: linear-gradient(90deg, #347efc, #6edafe);
  box-shadow: 0 12px 11px 0 rgba(29, 104, 250, 0.13);
  border-radius: 36px;
}

.butt_A:hover {
  background: linear-gradient(90deg, #347efc, #347efc);
}

.butt_B {
  cursor: pointer;
  text-align: center;
  width: 191px;
  height: 54px;
  font-size: 18px;
  color: #000000;
  background-color: aliceblue;
  border: 1px solid #000000;
  box-shadow: 0 12px 11px 0 rgba(29, 104, 250, 0.13);
  border-radius: 36px;
}

.butt_B:hover {
  background: linear-gradient(90deg, #347efc, #347efc);
  border: 0cm;
  color: #edf3fc;
}

.main_B6 {
  width: 1700px;
  margin: 0 auto;
  padding-top: 100px;
  background-color: #edf3fc;
}

.main_B6_div {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.main_B6_div > div {
  /* background-color: #0e0b3d; */
  /* height: 278px; */
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.main_B6_div_A {
  width: 262px;
  height: 165px;
  box-sizing: border-box;
  padding-top: 20px;
  /* margin-top: 33px; */
  background: #edf3fc;
  text-align: left;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: 50px;
}

.main_B6_div_A_box {
  padding: 20px 10px 20px 10px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 0px 29px 7px;
}

.main_B6_div_A_box > div {
  margin: 2px;
}

.imgs_text {
  display: flex;
  justify-content: left;
}

.top_text {
  font-size: 15px;
  color: #18181b;
  margin: 0 auto;
}

.img_text {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-family: SourceHanSansCN-Medium;
  color: #18181b;
}

.main_B6_div_B_img {
  width: 276px;
  margin-top: 150px;
}

.textB6 {
  margin-left: 45px;
}

.main_B6_div_B {
  width: 262px;
  height: 165px;
  box-sizing: border-box;
  /* padding-top: 20px; */
  /* margin-top: 33px; */
  background: #edf3fc;
  text-align: left;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.main_B6_div_D_div {
  width: 152px;
  height: 145px;
  background: #8d7bf7;
  margin-top: 52px;
  border-radius: 9px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.main_B6_div_D_div_text1 {
  font-size: 34px;
  font-weight: 700;
  color: #edf3fc;
  box-sizing: border-box;
  padding-left: 22px;
  margin-top: 18px;
  text-align: center;
}

.main_B6_div_D_div_text2 {
  font-size: 17px;
  font-family: SourceHanSansCN-Medium;
  color: #edf3fc;
  width: 70%;
  margin: 30px auto 0;
  text-align: center;
}

.main_B6_div > div:hover {
  transform: scale(1.1);
  transition: all 0.6s;
}

.main_B6_div > div {
  transform: scale(1);
  transition: all 0.6s;
}

.div_8 {
  width: 1400px;
  margin: 0 auto;
}

.div_8_div {
  margin-top: 140px;
}

.div_8_top_text {
  margin-bottom: 30px;
  font-size: 16px;
  font-family: SourceHanSansCN-Regular;
  color: #9198a9;
}

.div_8_bot_div {
  display: flex;
  justify-content: space-between;
}

.div_8_bot_div > div:hover {
  transform: translate(0, -20px);
  transition: all 0.6s;
}

.div_8_bot_div > div {
  /* transform:translate(0,-20px); */
  transition: all 0.6s;
}

.div_9 {
  width: 1400px;
  margin: 0 auto;
}

.div_9_div {
  margin-top: 140px;
}

.div_9_top_text {
  margin-bottom: 100px;
  font-size: 40px;
  color: #1b2336;
  text-align: center;
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
}

.div_9_bot_div {
  display: flex;
  justify-content: space-between;
}

.div_10_div {
  width: 1200px;
  margin: 0 auto;
}

.div_10_top_text {
  margin-top: 100px;
  font-size: 40px;
  color: #1b2336;
  text-align: center;
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
}

.div_10_bot_div {
  width: 1400px;
  display: flex;
  justify-content: center;
}

.div_9_bot_div > div:hover {
  transform: translate(0, -20px);
  transition: all 0.6s;
}

.div_9_bot_div > div {
  /* transform:translate(0,-20px); */
  transition: all 0.6s;
}

.div_9_bot_div_H1 {
  text-align: center;
  font-size: 20px;
  color: #242331;
  margin-top: 25px;
  text-align: center;
  font-family: SourceHanSansCN-Medium;
}

.div_9_bot_div_H2 {
  font-size: 16px;
  color: rgba(20, 23, 24, 0.75);
  margin-top: 20px;
  line-height: 25px;
  width: 236px;
  text-align: left;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #edf3fc;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #edf3fc;
}

.carousel_img {
  display: flex;
  justify-content: space-between;
}

.carousel_img_Htop {
  width: 540px;
  font-size: 20px;
  font-family: SourceHanSansCN-Medium;
  color: #141718;
  line-height: 30px;
  text-align: left;
}

.carousel_img_Htop_lis {
  text-align: left;
  margin-top: 50px;
}

.carousel_img_Htop_li {
  font-size: 16px;
  color: #414344;
  position: relative;
  margin: 10px;
}

.carousel_img_div {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.bust_lo {
  margin-top: 48px;
  width: 170px;
  height: 48px;
  background: #1a73e8;
  border-radius: 25px;
  font-size: 18px;
  color: #edf3fc;
  display: block;
  cursor: pointer;
}

.lp_top_text {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-family: SourceHanSansCN-Medium;
  color: #000;
}

.div_3_overflow_y {
  /* height: 700px; */
  /* overflow-y:scroll; */
}

.div_3_overflow_div {
  height: 600px;
}

.div_3_overflow_div_div {
  margin: 0 auto;
  width: 1400px;
  display: flex;
  justify-content: space-between;
}

.div_3_overflow_div_div_lef {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.div_3_overflow_div_div_lef > div {
  text-align: left;
}

.div_3_overflow_div_div_lef > div:nth-child(1) {
  font-size: 38px;
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
  color: #141718;
  margin-top: 26px;
}

.div_3_overflow_div_div_lef > div:nth-child(2) {
  font-size: 18px;
  font-family: SourceHanSansCN-Regular;
  color: #141718;
  width: 86%;
  line-height: 29px;
  margin-top: 26px;
}

.div_3_overflow_div_div_lef > div:nth-child(3) {
  display: flex;
  justify-content: left;
  margin-bottom: 35px;
  margin-top: 60px;
}

.div_3_overflow_div_div_lef > div:nth-child(4) {
  display: flex;
  justify-content: left;
}

.lef_text_top {
  font-size: 18px;
  font-family: SourceHanSansCN-Regular;
  color: #141718;
  line-height: 21px;
}

.lef_text {
  font-size: 14px;
  font-family: SourceHanSansCN-Regular;
  color: #414344;
  line-height: 20px;
  margin-top: 12px;
}

.div_11_bot_div {
  width: 100%;
  max-width: 1400px;
  margin: 60px auto 0;
  display: flex;
  flex-wrap: wrap;
  column-gap: 40px;
  row-gap: 78px;
}

.div_11_bot_div > div:hover {
  transform: translate(0, -20px);
  transition: all 0.6s;
}

.div_11_bot_div > div {
  transition: all 0.6s;
}

.div_12_map {
  width: 964px;
  margin: 0 auto;
  position: relative;
}

.map_li {
  width: 10px;
  height: 10px;
  background-color: #6f4287;
  border-radius: 50%;
  position: absolute;
}

.map_li:nth-child(2) {
  left: 577px;
  top: 130px;
}

.map_li:nth-child(3) {
  left: 483px;
  top: 245px;
}

.map_li:nth-child(4) {
  left: 335px;
  top: 44px;
}

.map_li:nth-child(5) {
  left: 262px;
  top: 318px;
}

.map_li:nth-child(6) {
  left: 148px;
  top: 165px;
}

.map_li:nth-child(7) {
  left: 726px;
  top: 210px;
}

.map_li:nth-child(8) {
  left: 760px;
  top: 92px;
}

.div_12 {
  width: 100%;
  margin: 0 auto;
  background: radial-gradient(closest-side at 50% 50%, #6f4287 0, #34187f 100%) 0 0 no-repeat padding-box;
}

.div_12_div {
  margin-top: 50px;
}

.div_12_top_text {
  margin-bottom: 100px;
  font-size: 40px;
  color: #edf3fc;
  text-align: center;
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
}

.div_12_bot_div {
  display: flex;
  justify-content: space-between;
}

.mapname {
  text-align: center;
  padding: 10px 20px 10px 20px;
  color: #edf3fc;
  width: 50px;
  height: 10px;
  background-color: #0e0b3d;
  border-radius: 25px;
}

.hyzx_main_body {
  width: 1400px;
  margin: 0 auto;
}

.hyzx_main_body_text {
  margin-bottom: 100px;
  margin-top: 80px;
  font-size: 40px;
  color: #1b2336;
  text-align: center;
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
}

.hyzx_H {
  text-align: left;
  font-size: 15px;
  font-family: SourceHanSansCN-Medium;
  color: #242331;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  width: 88.91%;
  margin: 26px auto 0;
}

.hyzx_text {
  text-align: left;
  font-size: 14px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  color: rgba(11, 10, 51, 0.57);
  line-height: 22px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
  width: 88.91%;
  margin: 21px auto 0;
}

.hyzx_but {
  display: flex;
  justify-content: right;
  padding-right: 32px;
}

.bust_hyzx {
  display: flex;
  font-size: 14px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 500;
  color: #1967d2;
  align-items: center;
  justify-content: flex-end;
}

.text_div {
  width: 420px;
}

.text_div:hover {
  box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px,
  rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;
}

.hyzx_main_body_divs {
  display: flex;
  justify-content: space-between;
}

.pphz_main {
}

.pphz_main_div_H {
  font-size: 24px;
  color: #9198a9;
  text-align: center;
  font-family: SourceHanSansCN-Medium;
  font-weight: 400;
  margin-top: 100px;
  margin-bottom: 100px;
}

.img_pphz {
  width: 208px;
}

.gywm_but {
  display: flex;
  justify-content: left;
  flex-direction: column;
}

.gywm_but button {
  text-align: left;
  margin: 0;
}

.yycj_div {
  display: flex;
  justify-content: space-around;
}

.yycj_div button {
  margin: 0;
}

.yycj_div > div {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.gywm_but_i {
  margin-right: 10px;
}

/* .font-size: 14px;
    font-family: SourceHanSansCN-Light;
    font-weight: 300;
    color: #edf3fc; */
/* .div_3_overflow_div_div_lef>div:nth-child(5){
font-size: 38px;
font-family: SourceHanSansCN-Medium;
font-weight: 400;
color: #141718;
margin-top: 26px;
} */
/* transform: scale(1.2); */
/* transform: scale(1.4); */
</style>

<style>
.map_li {
  width: 48px;
  height: 48px;
  display: block;
  position: relative;
  border-radius: 50%;
  background-color: #34187f;
  z-index: 1;
}

.map_li::after {
  width: 100%;
  height: 100%;
  content: "";
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -2;
  background-color: #34187f;
  animation: map_li-play 1s linear 400ms infinite;
}

.map_li::before {
  width: 100%;
  height: 100%;
  content: "";
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  background-color: #34187f;
  animation: dot-play 0.5s linear 100ms infinite;
  animation-delay: 0.5s;
  /* 延迟 2s */
}

@keyframes map_li-play {
  from {
    transform: scale(1);
    opacity: 0.4;
  }

  to {
    transform: scale(4);
    opacity: 0;
  }
}
</style>

<style>
@keyframes rowup {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(0);
  }

  100% {
    -webkit-transform: translateX(0);
    transform: translateX(-50%);
  }
}

.list {
  margin: 40px auto;
  position: relative;
  overflow: hidden;
}

.list .rowup {
  -webkit-animation: 30s rowup linear infinite normal;
  animation: 30s rowup linear infinite normal;
  position: relative;
}

.rowup {
  display: flex;
  justify-content: space-between;
}

@keyframes rowupA {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(-100%);
  }

  100% {
    -webkit-transform: translateX(-50%);
    transform: translateX();
  }
}

.listA {
  position: relative;
  overflow: hidden;
}

.listA .rowupA {
  -webkit-animation: 80s rowupA linear infinite normal;
  animation: 80s rowupA linear infinite normal;
  position: relative;
}

.rowupA {
  display: flex;
  justify-content: space-between;
}
</style>
